module.exports = __webpack_public_path__ + "img/admin-performance-stats.5fc2f2ed.png";